import React, { useMemo, useState } from 'react';
import { useNavigate } from "react-router-dom";
import ContextMenu, { Position } from 'devextreme-react/context-menu';
import List from 'devextreme-react/list';
import { useAuth } from '../../contexts/auth';
import './UserPanel.scss';
import { localStorageService } from '../../services/localstorage-service';
import { Tooltip } from 'devextreme-react/tooltip';
import { authenticationService } from '../../services/AuthService'
import { UserRoleType } from '../../utils/user-role-type';

export default function UserPanel({ menuMode }) {
  const { user, signOut } = useAuth();
  const navigate = useNavigate();
  const [tooltipvisible, setTooltipvisible] = useState(false);
  const [isChecked, setIsChecked] = useState(localStorageService.getIsChecked());
  const toggleDefault = () => {
    setTooltipvisible(!tooltipvisible);
  }

  async function onRememberMeChange(e) {
    let isRememberMe = e.target.checked;
    let response = await setRememberMe(e.target.checked);
    if (response && response.employee) {
      let currentToken = localStorageService.getAuthToken()
      if (currentToken) {
        setIsChecked(isRememberMe);
        setLocalStorage(response, isRememberMe);
      }
    }
  };

  const setRememberMe = async (isChecked) => {
    return await authenticationService.setRememberMe(isChecked);
  }


  const viewDashboards = async () => {
    navigate("/dashboardList");
  }

  const storeEmployeeSelected = async (item) => {
    if (!item.itemData.isSelected) {
      let isRememberMe = localStorageService.getIsChecked();
      let response = await authenticationService.setStore(isRememberMe ?? false, item.itemData.id);
      if (response && response.employee) {
        let currentToken = localStorageService.getAuthToken()
        if (currentToken) {
          setIsChecked(isRememberMe);
          setLocalStorage(response, isRememberMe, true);
          window.location.reload(true);
        }
      }
    }
  }
  function setLocalStorage(response, isRememberMe, isStoreSelected = false) {
    localStorageService.setIsChecked(isRememberMe);
    localStorageService.setAuthToken(response.token);
    localStorageService.setUserName(response.employee.name);
    if (isStoreSelected)
      localStorageService.setStoresEmployee(JSON.stringify(response.storeEmployee));
    localStorageService.setEmail(response.employee.chainName + ':' + response.employee.email);
    const supplierAccess = response.supplierAccess ?? response.SupplierAccess;
    if (supplierAccess) {
      localStorageService.setSupplierAccess(supplierAccess);
    } else {
      localStorageService.setSupplierAccess(null);
    }
  }

  function createStoreList() {
    const storeList = [];
    let storeEmployee = localStorageService.getStoresEmployee();
    const userRole = localStorageService.getUserRoleType();
    // Store name(s) first so the current store is shown at the top of the profile menu.
    if (storeEmployee !== null && storeEmployee !== undefined) {
      for (let i = 0; i < storeEmployee.length; i++) {
        storeList.push({
          id: storeEmployee[i].storeId,
          text: storeEmployee[i].storeName,
          onClick: storeEmployeeSelected,
          isSelected: storeEmployee[i].isCurrentStore
        });
      }
    }
    storeList.push({
      id: 0,
      text: 'Husk meg',
      isSelected: false
    });
    if (userRole.includes(UserRoleType.MANAGER)) {
      storeList.push(
        {
          id: 0,
          text: 'Se dashbord',
          onClick: viewDashboards,
          isSelected: false

        }
      );
    }
    storeList.push({
      id: 0,
      text: 'Logg ut',
      onClick: signOut,
      isSelected: false
    });

    return storeList;
  }

  const renderMenuItem = (itemData) => {
    if (itemData.text === 'Husk meg') {
      return (
        <><input type="checkbox" id="Huskmeg" style={{ marginLeft: '0px' }} name={itemData.text} checked={isChecked} onChange={e => onRememberMeChange(e)}></input><b style={{ paddingLeft: '5px' }}>{itemData.text}</b></>
      );
    }
    if (itemData.text === 'Logg ut') {
      return (
        <><div><span id="LoggUt" name={itemData.text}><img src={'/exit.png'} alt='' style={{ width: '15px', verticalAlign: '-1px' }} /><b style={{ paddingLeft: '2px' }}>{' ' + itemData.text}</b></span></div></>
      );
    }
    if (itemData.id > 0 && itemData.isSelected === true) {
      return (
        <><span id="store" className='menuItemDisabled' name={itemData.text}><b>{' ' + itemData.text}</b></span></>
      );
    }
    else {
      return (
        <><div style={{ 'paddingLeft': "21px" }}>{itemData.text}</div></>
      );
    }
  }
  const menuItems = useMemo(() => createStoreList(), []);
  return (
    <div className={'user-panel'}>
      <div className={'user-info'}>
        <div className={'image-container'}>
          <div
            style={{
              background: `url(${'/user.png'}) no-repeat #fff`,
              backgroundSize: 'cover'
            }}
            className={'user-image'} />
        </div>
        <div id="userName" className={'user-name'} onMouseEnter={toggleDefault} onMouseLeave={toggleDefault}>
          <Tooltip
            target="#userName"
            visible={tooltipvisible}
            hideOnOutsideClick={true}
          >
            <div>{user}</div>
          </Tooltip>
        </div>
      </div>
      {menuMode === 'context' && (
        <ContextMenu
          items={menuItems}
          target={'.user-button'}
          showEvent={'dxclick'}
          width={210}
          hoverStateEnabled={true}
          cssClass={'user-menu'}
          itemRender={renderMenuItem}
        >
          <Position my={'top center'} at={'bottom center'} />
        </ContextMenu>
      )}
      {menuMode === 'list' && (
        <List className={'dx-toolbar-menu-action'} items={menuItems} />
      )}
    </div>
  );
}
